<template v-if="pageLoader.loading.value">
    <div class="dashboard">
        <dashboard-sidebar />
        <div class="dashboard__content">
            <div class="row m-0 welcome__row">
                <div class="col-md-12">
                    <p class="h2"><i18n-t keypath="dashboard.welcome" /></p>
                    <p class="h2 word-blue username">{{ userFullName }}</p>
                </div>
            </div>
            <div class="row m-0 welcome__row">
                <div class="welcome__col">
                    <div
                        v-if="!isProspect && canShowOrdersPage"
                        class="welcome__card"
                        v-bind:style="{
                            backgroundImage: `url(${
                                storageApi + filteredPageData.top_card_background
                            })`,
                        }"
                    >
                        <div class="welcome__card-top">
                            <p class="fz-bigger welcome__card-title">
                                {{ filteredPageData.top_card_title }}
                            </p>
                            <div v-html="filteredPageData.top_card_description"></div>
                            <router-link
                                to="/auth/my-carconnex/my-orders/to_approve"
                                v-slot="{ navigate, href }"
                                custom
                            >
                                <a
                                    class="button button--sm button--outline"
                                    :href="href"
                                    @click.prevent="
                                        appCompanyStatusDialogModel.show() || navigate()
                                    "
                                >
                                    <i18n-t keypath="dashboard.viewDetailsBtn" />
                                </a>
                            </router-link>
                        </div>
                        <!-- <div class="welcome__card-bottom" >
                            <p class="ttu orders__qty-title">
                                <i18n-t keypath="dashboard.orders" />
                            </p>
                            <div class="orders__qty">{{ ordersQuantity }}</div>
                        </div> -->
                    </div>
                    <app-account-manager v-if="!shouldHideAccountManager"/>
                </div>
                <div class="welcome__col">
                    <router-link
                        v-for="icon in filteredPageData.sections"
                        v-bind:key="icon"
                        class="welcome__card--sm"
                        :to="'/auth' + icon.attributes.link"
                    >
                        <svg
                            class="icon"
                            width="48"
                            height="48"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <image
                                :href="storageApi + icon.attributes.icon"
                                width="48"
                                height="48"
                            />
                        </svg>
                        <div class="welcome__card-text">
                            <p class="welcome__card-title">
                                {{ icon.attributes.title }}
                            </p>
                            <p
                                class="fz-smaller welcome__card-subtitle"
                                v-html="icon.attributes.description"
                            ></p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { WelcomePage } from "@/dashboard/welcome-page/welcome-page";
export default WelcomePage;
</script>
